/* ---------------------------------------------------------------
   PureEthical - Construtor da gaveta de filtros no MOBILE (<1000px)
   Recria a mesma gaveta premium do desktop (Categoria/Genero/Tamanho/
   Cor/Marca + Ordenar) num painel deslizante. A logica de aplicar/limpar
   filtros continua a ser tratada pela delegacao de eventos do pe-collection.js.
   --------------------------------------------------------------- */
(function(){
  'use strict';

  function build(){
    // Desktop (>=1000px) constroi a sua propria gaveta em pe-collection.js
    if(window.innerWidth >= 1000) return;
    var bar = document.getElementById('filterBar');
    var panels = document.getElementById('filterPanels');
    if(!bar || !panels) return;
    if(document.querySelector('.pe-fd-trigger')) return; // ja construida

    var LABELS = { cat:'Categoria', gender:'Genero', size:'Tamanho', colour:'Cor', brand:'Marca' };
    var ORDER = ['cat','gender','size','colour','brand'];
    var FACET = '.fp-age-chip,.fp-size-pill,.fp-colour-item,.fp-brand-chip,.fp-gender-chip,.fp-quick-link,.fp-sort-chip';
    var COUNTABLE = '.fp-age-chip,.fp-size-pill,.fp-colour-item,.fp-brand-chip,.fp-gender-chip';

    panels.classList.add('pe-drawer');
    panels.style.setProperty('transform','translateX(-102%)','important');
    panels.style.setProperty('pointer-events','auto','important');
    // Forcar fundo BRANCO (o script base pode ter posto fundo escuro inline)
    panels.style.setProperty('background','#ffffff','important');
    panels.style.setProperty('background-color','#ffffff','important');
    panels.style.setProperty('background-image','none','important');
    panels.style.setProperty('border-top','none','important');

    var head = document.createElement('div');
    head.className = 'pe-fd-head';
    head.innerHTML = '<div class="pe-fd-head-txt"><span class="pe-fd-eyebrow">'+(window.PE_T?window.PE_T('refine','Afinar seleção'):'Afinar seleção')+'</span><span class="pe-fd-title">'+(window.PE_T?window.PE_T('filters','Filtros'):'Filtros')+'</span></div><button class="pe-fd-close" type="button" aria-label="'+(window.PE_T?window.PE_T('close_x','Fechar'):'Fechar')+'">&times;</button>';

    var scroll = document.createElement('div');
    scroll.className = 'pe-fd-scroll';

    var foot = document.createElement('div');
    foot.className = 'pe-fd-foot';
    foot.innerHTML = '<button class="pe-fd-clear" type="button">Limpar tudo</button><button class="pe-fd-apply" type="button" data-apply>Ver resultados</button>';

    // Ordenar - bloco no topo
    var sortPan = document.getElementById('panel-sort');
    if(sortPan && sortPan.querySelector('.fp-sort-chip')){
      sortPan.classList.add('fp-active');
      sortPan.style.setProperty('display','block','important');
      var sblk = document.createElement('div');
      sblk.className = 'pe-fd-sortblock';
      var slbl = document.createElement('span');
      slbl.className = 'pe-fd-sortlbl';
      slbl.textContent = (window.PE_T?window.PE_T('sort_by','Ordenar por'):'Ordenar por');
      sblk.appendChild(slbl);
      sblk.appendChild(sortPan);
      scroll.appendChild(sblk);
    }

    // Seccoes em acordeao
    ORDER.forEach(function(pid){
      var pan = document.getElementById('panel-' + pid);
      if(!pan || !pan.querySelector(FACET)) return;
      pan.classList.add('fp-active');
      pan.style.setProperty('display','block','important');
      var n = pan.querySelectorAll(COUNTABLE).length;
      var sec = document.createElement('div');
      sec.className = 'pe-fd-sec';
      var hd = document.createElement('button');
      hd.type = 'button';
      hd.className = 'pe-fd-sec-hd';
      hd.innerHTML = '<span class="pe-fd-lbl">' + (LABELS[pid] || pid) + '</span><span class="pe-fd-meta">' + (n > 0 ? '<span class="pe-fd-n">' + n + '</span>' : '') + '<span class="pe-fd-ico" aria-hidden="true"></span></span>';
      var bd = document.createElement('div');
      bd.className = 'pe-fd-sec-body';
      bd.appendChild(pan);
      sec.appendChild(hd);
      sec.appendChild(bd);
      scroll.appendChild(sec);
      hd.addEventListener('click', function(){
        var was = sec.classList.contains('pe-open');
        var opened = scroll.querySelectorAll('.pe-fd-sec.pe-open');
        for(var i = 0; i < opened.length; i++){ opened[i].classList.remove('pe-open'); }
        if(!was){ sec.classList.add('pe-open'); }
      });
    });

    panels.innerHTML = '';
    panels.appendChild(head);
    panels.appendChild(scroll);
    panels.appendChild(foot);
    var first = scroll.querySelector('.pe-fd-sec');
    if(first){ first.classList.add('pe-open'); }
    document.body.appendChild(panels);

    var backdrop = document.createElement('div');
    backdrop.id = 'pe-fd-bd';
    document.body.appendChild(backdrop);

    var trig = document.createElement('button');
    trig.type = 'button';
    trig.className = 'pe-fd-trigger';
    trig.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 5h18M6 12h12M10 19h4"/></svg> Filtrar';
    var sc2 = bar.querySelector('.filter-bar-scroll');
    if(sc2){ sc2.insertBefore(trig, sc2.firstChild); }

    function topPx(){
      var h = document.querySelector('.site-header');
      return h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 56;
    }
    function openD(){
      var t = topPx();
      panels.style.setProperty('top', t + 'px', 'important');
      backdrop.style.setProperty('top', t + 'px', 'important');
      panels.style.setProperty('transform','translateX(0)','important');
      panels.style.setProperty('pointer-events','auto','important');
      panels.classList.add('pe-open');
      backdrop.classList.add('pe-open');
      document.documentElement.style.overflow = 'hidden';
      panels.querySelectorAll('.fp-inner').forEach(function(p){
        p.classList.add('fp-active');
        p.style.setProperty('display','block','important');
      });
    }
    function closeD(){
      panels.style.setProperty('transform','translateX(-102%)','important');
      panels.classList.remove('pe-open');
      backdrop.classList.remove('pe-open');
      document.documentElement.style.overflow = '';
    }

    trig.addEventListener('click', function(e){ e.stopPropagation(); openD(); });
    head.querySelector('.pe-fd-close').addEventListener('click', closeD);
    backdrop.addEventListener('click', closeD);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeD(); } });
    // "Ver resultados" - a delegacao do pe-collection.js trata do data-apply; aqui so fechamos
    foot.querySelector('.pe-fd-apply').addEventListener('click', function(){ setTimeout(closeD, 60); });
    // "Limpar tudo" - volta a colecao base sem tags/parametros
    foot.querySelector('.pe-fd-clear').addEventListener('click', function(){
      var p = ('/'+window.location.pathname.replace(/^\/+/,'')).split('/collections/');
      window.location.href = p[0] + '/collections/' + (p[1] || '').split('/')[0].split('?')[0];
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
